module.exports = __webpack_public_path__ + "media/images/pages/img_shopping_02-ebde543f604de0c5881071424e8d4da2.jpg";